module.exports = __webpack_public_path__ + "images/gavdos/news1.jpg";